import React from 'react';
import {render} from 'react-dom';
import {getSetting} from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/settings';
import SessionTimeoutNotifier from './SessionTimeoutNotifier';
import {logout} from '../../js/logout';

const {document} = window;

const getNumericSetting = async (settingName: string): Promise<number> => {
    const value = await getSetting(settingName);
    try {
        return parseInt(value, 10);
    } catch {
        return 0;
    }
};

export const initializeSessionTimeoutNotifier = async (): Promise<void> => {
    const warningTimeout = await getNumericSetting('session_timeout_warning');
    const sessionTimeout = await getNumericSetting('session_timeout');

    if (sessionTimeout !== 0) {
        const modalEl = document.createElement('div');
        modalEl.style.position = 'absolute';
        modalEl.style.width = '100%';
        document.body.appendChild(modalEl);

        render(
            <SessionTimeoutNotifier
                warningTimeout={warningTimeout}
                onSessionExpired={logout}
            />, modalEl
        );
    }
};
